import { render } from "./PrcMobileApp2.vue?vue&type=template&id=26dd785e&scoped=true"
import script from "./PrcMobileApp2.vue?vue&type=script&lang=js"
export * from "./PrcMobileApp2.vue?vue&type=script&lang=js"

import "./PrcMobileApp2.vue?vue&type=style&index=0&id=26dd785e&lang=less&scoped=true"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26dd785e"]])

export default __exports__